
{
  "fr": {
    "mandat": "Mandat",
    "sepa": "SEPA"
  }
}
